import { useState, useEffect, useCallback } from 'react';
import { getMatches } from '@/api/TournamentManagement/matchApi';
import type { MatchListView, MatchListQuery } from '@/models/tournament';

export function useMatches(query: MatchListQuery) {
  const [data, setData] = useState<MatchListView | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getMatches(query);
      if (result.status < 400 && result.errors.length === 0) {
        setData(result.payload);
      } else {
        setError(result.errors[0]?.description || 'An error occurred');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  }, [query.tournamentId, query.search, query.status, query.location, query.pitch, query.ageCategory, query.division, query.completedOnly, query.refereeUserId, query.sortBy, query.sortDescending, query.page, query.pageSize]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
}
